export default "__VITE_ASSET__7955c844__"